import BusinessIcon from '@material-ui/icons/Business';
import PeopleOutlineIcon from '@material-ui/icons/PeopleOutline';
import { Autocomplete, Checkbox, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useCompany } from '../../../providers';
import useLocPeopleIndex from './hooks/useLocPeopleIndex';

const UserAutocomplete = ({ location, setSelected, selected }) => {
   const { company } = useCompany();
   const options = useLocPeopleIndex(company.cid, location);
   const [inputValue, setInputValue] = useState('');

   return (
      <Autocomplete
         multiple
         options={options}
         getOptionLabel={(option) => option.name}
         filterOptions={(options, { inputValue }) => {
            if (inputValue.length < 1) {
               return options;
            }
            return options.filter((option) => {
               const nameMatch = option.name
                  .toLowerCase()
                  .includes(inputValue.toLowerCase());
               if (option.email) {
                  return (
                     nameMatch ||
                     option.email.toLowerCase().includes(inputValue.toLowerCase())
                  );
               }
               return nameMatch;
            });
         }}
         renderOption={(props, option, { selected }) => {
            const { key, ...optionProps } = props;
            if (option.type === 'location') {
               return (
                  <li key={key} {...optionProps}>
                     <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                        readOnly
                        size="small"
                     />
                     <BusinessIcon style={{ marginRight: 8 }} />
                     <Typography variant="body2">{option.name}</Typography>
                  </li>
               );
            } else if (option.type === 'group') {
               return (
                  <li key={key} {...optionProps}>
                     <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                        readOnly
                        size="small"
                     />
                     <PeopleOutlineIcon style={{ marginRight: 8 }} />
                     <Typography variant="body2">{option.name}</Typography>
                  </li>
               );
            } else {
               return (
                  <li key={key} {...optionProps}>
                     <Checkbox
                        checked={selected}
                        style={{ marginRight: 8 }}
                        readOnly
                        size="small"
                     />

                     <Typography variant="body2">{option.name}</Typography>
                  </li>
               );
            }
         }}
         disableCloseOnSelect
         renderInput={(params) => (
            <TextField
               {...params}
               variant="outlined"
               margin="normal"
               required
               fullWidth
               id="users"
               label="Users/Groups"
               name="users"
               value={inputValue}
               onInput={(e) => {
                  setInputValue(e.target.value);
               }}
            />
         )}
         value={selected}
         onChange={(event, newValue) => {
            if (newValue.type == 'location') {
            } else if (newValue.length === 'group') {
            } else {
               setSelected(newValue);
            }
         }}
         noOptionsText={
            inputValue.length < 1
               ? `Start typing to find your details (${
                    1 - inputValue.length
                 } more characters)`
               : 'No options'
         }
         fullWidth
      />
   );
};
export default UserAutocomplete;
